import CommonHelmet from '@src/components/CommonHelmet';
import ResetPasswordForm from '@src/features/company/auth/ResetPasswordForm';
import CompanyCenterCardLayout from '@src/layouts/company/CompanyCenterCardLayout';

function CompanyTenantResetPassword() {
  return (
    <>
      <CompanyCenterCardLayout>
        <CommonHelmet />
        <ResetPasswordForm />
      </CompanyCenterCardLayout>
    </>
  );
}

export default CompanyTenantResetPassword;
